import { render, staticRenderFns } from "./StudentEOIDetails.vue?vue&type=template&id=32e421b1&scoped=true&"
import script from "./StudentEOIDetails.vue?vue&type=script&lang=js&"
export * from "./StudentEOIDetails.vue?vue&type=script&lang=js&"
import style0 from "./StudentEOIDetails.vue?vue&type=style&index=0&id=32e421b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e421b1",
  null
  
)

export default component.exports